import { Component, OnDestroy, OnInit } from '@angular/core';
import { SyllabusResponseAI } from '@edtech-ui/core/models/ai-course/ai-generate-syllabus';
import { CourseManagementService } from '@edtech-ui/core/services/course-management/course-management.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { catchError,tap } from 'rxjs/operators';
import { of, Subscription } from 'rxjs';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-course-view',
	standalone: true,
	imports: [CommonModule, MatExpansionModule, MatIconModule, MatProgressSpinnerModule],
	templateUrl: './course-view.component.html',
	styleUrls: ['./course-view.component.scss']
})
export class CourseViewComponent implements OnInit, OnDestroy {

	_syllabusData: SyllabusResponseAI['Data'] | null = null;
	classroomId: number | string | undefined;
	courseId: string | null = null;
	subscription =new Subscription();

	constructor(
		private _courseService: CourseManagementService,
		private route: ActivatedRoute,
		private router: Router,
		private _toastr: ToastrService,
	) { }

	ngOnInit(): void {
		this.route.paramMap.subscribe(params => {
			const classroomId = params.get('classroomId');
			const courseId = params.get('courseId');
			if (classroomId) {
				this.classroomId = +classroomId;
			}
			if (courseId) {
				this.courseId = courseId;
			}

			if (this.courseId && this.classroomId) {
				this.getCourseDetailsById();
			}
		});
	}

	getCourseDetailsById() {
		this.subscription.add(
		this._courseService.getCoursesByCourseId(this.courseId!).pipe(
				tap((response: SyllabusResponseAI) => {
					if (response.Success) {
						this._syllabusData = response.Data;
					} else {
						this._toastr.error(response.Message);
					}
				}),
				catchError(() => {
					this._toastr.error('Something went wrong while fetching the course details');
					return of(null);
				})
			).subscribe()
		)
	}

	goBackToResources() {
		if (this.classroomId) {
			this.router.navigate(['/student-dashboard/classroom-detail-page', this.classroomId,'course']);
		} else {
			this.router.navigate(['/student-dashboard/classrooms']);
		}
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}